/**
 * Sets blank layout in webview, otherwise default.
 */
export default defineNuxtRouteMiddleware(() => {
  const { isWebView } = usePlatform()

  setPageLayout(isWebView.value ? 'blank' : 'default')
})
